import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* List Transactions */
export const list = ({ page = 1, search = "", operators = "", tables = "", start = "", end = "", status = "", type = "", refund = "", testers = true, vips = true }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ page: page || 1, timezone: utils.getTimezone() })

    if (search) params.set("search", search)
    if (operators) params.set("operators", operators)
    if (tables) params.set("tables", tables)
    if (start) params.set("start", start)
    if (end) params.set("end", end)
    if (status !== "") params.set("status", status)
    if (type) params.set("type", type)
    if (refund !== "") params.set("refund", refund)
    if (!testers) params.set("testers", "0")
    if (!vips) params.set("vips", "0")

    /* Send Request */
    const uri = `${env.startpoint}transaction/list?${params.toString()}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Transaction Detail */
export const detail = (id) => {

    const uri = `${env.startpoint}transaction/detail?id=${id}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section (операторы и игры — строго в рамках доступа токена) */
export const filters = () => {

    const uri = `${env.startpoint}transaction/filters`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}
